import { useAppSelector } from '../../../../state/hooks';
import { isConfigurationDialogOpen } from '../../state/onboardingUiSlice';
import { useSelectedVehicle } from '../../../../state/vehicles/useVehicles';
import { AddNewServiceCardDialog } from './addNewCardDialog/AddNewServiceCardDialog';
import { ServiceConfigurationDialog } from './serviceConfigurationDialog/ServiceConfigurationDialog';

export const VehicleServicesAndCardsDialog = () => {
  const showConfigurationDialog = useAppSelector(isConfigurationDialogOpen);
  const selectedVehicle = useSelectedVehicle();

  if (!selectedVehicle || !showConfigurationDialog) {
    return <></>;
  }

  return (
    <>
      <ServiceConfigurationDialog />
      <AddNewServiceCardDialog />
    </>
  );
};
